import React from "react";
import { Header, Body } from "../../../styleguide/atoms/index.js";
import { CharacterCard } from "./CharacterCard.js";
import { CardWrapper, IntelWrapper } from "../styles/Game.styles";
import * as styles from "../../../styleguide/styles/Stylesheet.js";

export default function YouAreCard({
  me,
  roleImage,
  roleDescNodes,
  intelList,
  isDay,
}) {
  if (!me) return null;

  const isAlive = me?.alive !== false;

  const hasShadowBond =
    me?.roleTitle === "The Shadow" && !!me?.meta?.shadowBondTargetName;
  const hasFanRoot =
    me?.roleTitle === "Anime Fan" && !!me?.meta?.fanRootTargetName;
  const hasHermitSabotageTarget =
    me?.roleTitle === "Hermit" && !!me?.meta?.hermitSabotageTarget;

  const hasIntelList = (intelList?.length || 0) > 0;
  const hasRoleIntel = hasShadowBond || hasFanRoot || hasHermitSabotageTarget;

  const showIntelBox = isAlive && (hasIntelList || hasRoleIntel);

  return (
    <CardWrapper>
      <Header
        type="h3"
        align="center"
        color={isDay ? styles.color_accent : styles.color_white}
      >
        You are:
      </Header>

      <CharacterCard
        image={roleImage || ""}
        description={roleDescNodes || null}
        role={me.team || ""}
        status={me.alive === false ? "Dead" : "Alive"}
        title={me.roleTitle || ""}
        listView={false}
        player={me?.name || ""}
        collapsable
      />

      {showIntelBox && (
        <IntelWrapper>
          {hasIntelList && (
            <>
              <Header type="h4" align="center" padding="0">
                Your Intel
              </Header>
              <Body align="center" color={styles.color_accent}>
                {intelList.map((r, idx) => (
                  <div key={r.id || r.text || idx} style={{ margin: 4 }}>
                    {r.type === "counselor_pair_result" ? (
                      <>
                        <b>
                          {r.aName} + {r.bName}:
                        </b>{" "}
                        {r.sameTeam ? "Same alignment!" : "Unaligned"}
                      </>
                    ) : r.type === "gossip_pair_result" ? (
                      <>
                        <b>{r.aName}</b> or <b>{r.bName}</b>:{" "}
                        {r.roleTitle || r.role || "Unknown role"}
                      </>
                    ) : r.type === "note" ? (
                      (() => {
                        const txt = String(r.text || "");

                        let m = /^<b>([\s\S]*?)<\/b>\s*([\s\S]*)$/i.exec(txt);
                        if (m) {
                          return (
                            <>
                              <b>{m[1]}</b> {m[2]}
                            </>
                          );
                        }

                        m = /^([\s\S]*?)<b>([\s\S]*?)<\/b>([\s\S]*)$/i.exec(
                          txt
                        );
                        if (m) {
                          return (
                            <>
                              <span>{m[1]}</span>
                              <b>{m[2]}</b>
                              <span>{m[3]}</span>
                            </>
                          );
                        }

                        return <span>{txt}</span>;
                      })()
                    ) : (
                      <>
                        <b>{r.name}:</b> {r.role ? `${r.role}` : null}
                        {r.role && r.align ? " • " : null}
                        {r.align ? `${r.align}` : null}
                        {!r.role && !r.align ? "—" : null}
                      </>
                    )}
                  </div>
                ))}
              </Body>
            </>
          )}

          {hasShadowBond && (
            <>
              <Header
                type="h4"
                align="center"
                padding={hasIntelList ? "24px 0 0" : "0"}
              >
                Your Bond
              </Header>
              <Body align="center" color={styles.color_accent}>
                {me.meta.shadowBondTargetName}
              </Body>
            </>
          )}

          {hasFanRoot && (
            <>
              <Header
                type="h4"
                align="center"
                padding={hasIntelList ? "24px 0 0" : "0"}
              >
                You are rooting for
              </Header>
              <Body align="center" color={styles.color_accent}>
                {me.meta.fanRootTargetName}
              </Body>
            </>
          )}

          {hasHermitSabotageTarget && (
            <>
              <Header
                type="h4"
                align="center"
                padding={hasIntelList ? "24px 0 0" : "0"}
              >
                You need to sabotage
              </Header>
              <Body align="center" color={styles.color_accent}>
                {me.meta.hermitSabotageTargetName}
              </Body>
            </>
          )}
        </IntelWrapper>
      )}
    </CardWrapper>
  );
}
